import React, { useState } from "react";
import Select from "react-select"; 
   
const SelectorComponent = ({ items, onItemSelected,Balance }) => {
 
  const [_selectedItem, setSelectedItem] = useState(null); // Track selected item

 // This is a fallback or a mock of the wallet items in case the API call fails
  

  // Transform items into options for react-select
  const options = items.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  // Handle selection change
  const handleSelectChange = (selectedOption) => {
    const selectedItem = items.find((item) => item.id === selectedOption.value);
    setSelectedItem(selectedItem); // Store selected item locally
    onItemSelected(selectedItem); // Pass the selected item to the parent
  };
 
 
  return (
    <>  
      <div className="col-xl-6 pe-xl-5">
     
 
        <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40 mt-2">
          {/* Balance Balance Input */}
         <h6>My Balance ${Balance}</h6>
            {/* Select Dropdown */}
            <div className="mb-24">
              <h7>Select withdrawal Method </h7>
              <Select
                options={options}
                onChange={handleSelectChange}
                placeholder="Select an item"
                isClearable
                menuPlacement="top"
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    position: 'absolute', // Adjusting the dropdown position
                    bottom: '100%', // To ensure it opens above the input
                  }),
                }}
              />
            </div>

              
         </div>
      </div>
    </>
  );
};

export default SelectorComponent;
